import {
  DiscountTarget,
  DistributionMode,
  EndDateType,
  GetDraftOfferResult,
  GetOfferResult,
  RewardType,
  QualifierSelectionMode,
  TargetLevel,
  DiscountType,
  ItemAttribute,
  CodeType,
  CodeFormat,
  RedeemType,
  PurchaseTypes,
  GetOfferDistributionSettingsResult,
  Channels,
  RedistributionMode,
  ScheduleDays,
  ListOffersResult,
  OfferStatusType,
} from '../offers-domain.types';

export const offers: ListOffersResult = {
  offers: [
    {
      offerId: '9243f7ee-bae8-4add-b6ec-42d3919c439b',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: 'Active Auto Offer',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: EndDateType.STATIC,
      redemptionStartDate: '2022-11-14T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: EndDateType.STATIC,
      distributionStartDate: '2022-09-14T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'FR',
          title: '%Bug Fix - 002%',
          shortDescription: '%Bug Fix - 002%',
          longDescription: '%Bug Fix - 002%',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/images_4b4906fa4a2d451190292edfcba09d8e.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Capture_349fe5fea8ac4ddab31f0e891c0024b7.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ITEM,
          discountItemQualifier: {
            qualifierItems: [
              {
                itemAttribute: ItemAttribute.ITEM,
                attributeId: '60997a3a60b20eb4a15d8dad',
                extAttributeId:
                  '6ed935ad-2379-44a6-9a6a-d51c6d9b0cb3-extTargetingId',
                attributeObjectName:
                  '2050 Yonge copy - DO NOT USE - Pizza Sauce',
                targetLevel: TargetLevel.ITEM,
                count: 1,
              },
              {
                itemAttribute: ItemAttribute.ITEM,
                attributeId: '60997a3960b20eb4a15d8d20',
                extAttributeId:
                  '5e9c6d74-6407-4e7e-906d-3e9cf6e10b15-extTargetingId',
                attributeObjectName:
                  '2050 Yonge copy - DO NOT USE - Pizza Sauce',
                targetLevel: TargetLevel.ITEM,
                count: 1,
              },
            ],
            qualifierSelectionMode: QualifierSelectionMode.ONE,
          },
          discountType: DiscountType.AMOUNT,
          discountAmount: 2000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.503aacf0-c5e7-4ca2-9843-adb525afdc97',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '11/14/2022 10:44:46',
      updatedDate: '01/26/2023 10:43:01',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: '48d32bd2-f81d-4aa5-9a92-5e457a3d24a5',
      campaignId: '7a83d9f0-c35e-4d82-b176-37de4f66ecaf',
      campaignTitle: 'test two',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: 'Scheduled Offer',
      offerStatus: OfferStatusType.SCHEDULED,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-11-15T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-11-15T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Scheduled Offer',
          shortDescription: 'Scheduled Offer',
          longDescription: 'Scheduled Offer',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Capture_7770560c70574a099d6d3a79a70aabb9.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/images_425eb8ad56c14ab4be41a743b4c9e7e7.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 2000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.9417d748-d4f4-41e0-9595-af7e782a5f0e',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '11/15/2022 12:01:23',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: false,
    },
    {
      offerId: 'bda2541b-cbfc-4833-9472-fd4bb95ff927',
      campaignId: '431f0f45-a012-43df-a96a-fa623ffb6fa7',
      campaignTitle: 'test three',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: 'Expired Offer',
      offerStatus: OfferStatusType.EXPIRED,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: {
        '*': '2f43febf-491a-4174-a9a8-afe827031088',
      },
      priority: 1,
      channelTemplateSetMap: {
        SMS: [
          {
            languageCode: 'EN',
            messageTemplate: 'Expired Offer',
          },
        ],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2021-06-18T00:00:00',
      redemptionEndDate: '2021-10-25T00:00:00',
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2021-04-20T00:00:00',
      distributionEndDate: '2021-08-20T00:00:00',
      awardPointsAsPending: false,
      distributionMode: DistributionMode.ACTIVITY,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Expired Offer',
          shortDescription: 'Expired Offer',
          longDescription: 'Expired Offer',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/ee_083cb267970640c2abc642d6c2cae9e5.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/ee_c8942737949e42299e5d1d687697af5b.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.PERCENTAGE,
          discountAmount: 0,
          discountPercentage: 0.1,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.39f85146-3519-4797-87e6-b6d28119c495',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"eventName\\":\\"check-in\\",\\"eventValues\\":[\\"7228c2cf-17d7-47bd-a069-0e0083ced402\\",\\"QA\\",null],\\"valueDefinition\\":[{\\"incentivioId\\":\\"7228c2cf-17d7-47bd-a069-0e0083ced402\\",\\"code\\":\\"QA\\",\\"copyToEventValues\\":\\"[\\\\\\"incentivioId\\\\\\",\\\\\\"code\\\\\\",\\\\\\"beaconid\\\\\\"]\\",\\"type\\":\\"PROMO\\",\\"displayData\\":\\"{\\\\\\"title\\\\\\":\\\\\\"QA\\\\\\"}\\"}]}","expressionName":"EVENT"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '05/18/2022 16:51:48',
      updatedDate: '10/19/2022 11:29:05',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: ['CHECK_IN'],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: '81adffc5-0699-462e-8891-5ccde13b8933',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: 'Active Activity Offer',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-05-19T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-05-19T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.ACTIVITY,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Active Activity Offer',
          shortDescription: 'Active Activity Offer',
          longDescription: 'Active Activity Offer',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/ii_20f7c912b0064415a0b1d45e32dfa3b1.png',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/ii_c7aa84de5cdc495cb5e4f1db22a9ec37.png',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.PERCENTAGE,
          discountAmount: 0,
          discountPercentage: 0.1,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.9c4cac9c-2a32-4c8b-a610-0152f669d2c0',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"eventName\\":\\"check-in\\",\\"eventValues\\":[\\"7228c2cf-17d7-47bd-a069-0e0083ced402\\",\\"QA\\",null],\\"valueDefinition\\":[{\\"incentivioId\\":\\"7228c2cf-17d7-47bd-a069-0e0083ced402\\",\\"code\\":\\"QA\\",\\"copyToEventValues\\":\\"[\\\\\\"incentivioId\\\\\\",\\\\\\"code\\\\\\",\\\\\\"beaconid\\\\\\"]\\",\\"type\\":\\"PROMO\\"}]}","expressionName":"EVENT"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '05/19/2022 10:24:52',
      updatedDate: '10/19/2022 11:29:05',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: ['CHECK_IN'],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: '9c17d6d1-428d-437d-bd4a-b6395fbd0057',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: '#####',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-11-16T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-11-16T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'EN',
          title: '#####',
          shortDescription: '#####',
          longDescription: '#####',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/Capture_dc734d7272e34e53842d6a6816b076b8.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/images_25537702187f435e8beb99b5f2f9a65c.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 3000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.5d28695f-e9cd-4d54-9267-6647d0f68736',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"NO_ONE"}',
      createdDate: '11/16/2022 10:23:04',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: 'af7c0992-fb65-4a1c-b471-d094f0ba379d',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: '%04% Offer',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-10-22T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-10-22T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'EN',
          title: '%04% Offer',
          shortDescription: 'Des',
          longDescription: 'a',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/3_40c4655ce5af48c68a8ad1ce3ec14d99.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/3_e4a6855fbf2c4f258662fe3a7e139871.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 1000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.0e0540e1-1102-4602-b78d-f4bf9678424c',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '10/21/2022 02:08:52',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: '4e49315f-c590-4ab2-9020-0db84827d4f8',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: '%05% Offer',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-10-21T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-10-21T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'EN',
          title: '%05%',
          shortDescription: 'm',
          longDescription: 'n',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/3_330d909ce14a4262b4eed750b87a8317.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/3_7f0b0d307b3a428eaa9049c5cb6a7242.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 6000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.6d22649f-d165-4100-91e7-f59ed821d515',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '10/21/2022 02:37:22',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: '42dc9941-cc0c-45d3-a85c-e0423a3f3738',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: '%1% Offer',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-10-20T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-10-20T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'FR',
          title: 'Test Order 03',
          shortDescription: 'Test',
          longDescription: 'test',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/2_483b5c332ea14782a76f958b8c8c6c8a.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/3_61325d70a40643a28a650e4213b7b1e0.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 1000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.212525f7-ab34-4252-b2d0-cc7e488c7cda',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"NO_ONE"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"NO_ONE"}',
      createdDate: '10/20/2022 19:02:07',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: true,
      reach:
        '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*"]',
      reachDisplayInfo:
        '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117\\u003dtest;185402a5-744e-4036-8e38-7b04ec8b3634\\u003dPhoenix Location","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c\\u003dElastiCache Testing;f6a868d1-2b4d-4dde-8e5a-da608add442c\\u003dElastiCache Migration 1","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12\\u003dDev Team Onlyy;e24a7c69-9caa-43bd-8247-5f9d3646da56\\u003dTest Store for Duplicate|1b7e9d78-4a01-497b-81a8-36c061db273d\\u003dDO NOT USE - HM Lake Mary|eaa78621-f849-4267-8235-1c280f8e183f\\u003dDEV TEAM - TOAST Copy|5c8f4f36-6f46-47de-8340-1eb542e3d7a4\\u003dCatalog Testing store 2 (Don\\u0027t Edit)|684118df-6aaa-4b8c-a01c-4714018d6330\\u003dDEV TEAM - SQUARE|1a972340-2b41-42d7-8dd0-ca7244a4c101\\u003dDEV TEAM - TOAST|feddeb45-997a-4eae-a32d-0acc3dceebfe\\u003dDEV TEAM - QU|c1f73a97-8a64-4bff-9f37-bd71b6ccdc56\\u003dDEV TEAM - SILVERWARE|12e9ccb5-c1db-47ad-864f-4fb533d18804\\u003dDEV TEAM - LIGHTSPEED|d92ba21d-3595-483f-84f6-915378f4eb88\\u003dDEV TEAM - REVEL|d672e224-a310-4e80-a389-550e09d82e66\\u003dDEV TEAM - BRINK|eef2bafb-7ade-4753-ad2c-3b783ed12f4e\\u003ddelete test|f58c34ac-7ee0-4d39-a663-ef5881b0a217\\u003d2050 Yonge copy - DO NOT USE|6d82d135-7eee-402f-8d63-9f6650aa35d9\\u003dTest New Store|8822e1ef-3f18-44b3-b311-fc4cbe589517\\u003dDEV TEAM - TEST|4cda6f5d-bd61-4669-866c-550356715b66\\u003dTest - Location|9f8aae09-49f8-4f68-b3d3-478838362254\\u003dBoston DEV|436e3b11-9d1f-4712-abca-875f432a0384\\u003dLightspeed 3|7ec07547-028e-4fce-9002-b850580f1752\\u003dDEV TEAM - OTTER|d1e60049-c35a-44f6-94d0-4af64c0ef53d\\u003dTest Store for test mode","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf\\u003dOtter Demo;98d87416-a53b-48a4-88cf-d8431e72cf47\\u003dOtter Demo Store","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c\\u003dINCENTIVIO;39df95a3-439a-4145-9560-aa2ec14d063e\\u003dDuplicate Store|747f00fe-1285-4001-8f5d-962ead578e9b\\u003dRegression Testing Store|3d922e86-2f3f-41b6-a1ce-19ffe94895ad\\u003dDecatur (Lightspeed)|5dad0de2-0a3b-41ee-aba6-6d928f0f39b0\\u003dFenway Kiosk New Dev (Don\\u0027t Edit)|fb6c1227-78b1-4d62-a670-c146ef060983\\u003dMilos QA Sync Test (NCC)|76cfba32-e232-49bf-acde-4aec97aef1f9\\u003dEnfield (QA US  DONT EDIT)|2efed814-f037-44d8-8475-a2772d43311e\\u003dDuplicate Store 2|560894f4-84a8-4f56-88ef-5e6f623d0859\\u003dQU Testing Store -QA|43a86007-a664-495a-bdac-fa90683283fc\\u003dTest Store22|419418fb-788d-461d-aad6-fb2d613cd830\\u003dClover Transaction Store|92988170-ccb2-4069-aae9-1e91fd65fd41\\u003dLightspeed - Without Tax Classes|e410319a-d820-4da2-b08e-5e3242188a28\\u003dToronto OTTER (QA Use)|7a631130-8800-4efa-bbab-4d159aa80945\\u003dDine in Boston QA2 (Incentivio KC Test)|91e91878-6dfb-4adc-b5dd-dd1f692c6a9c\\u003dLightspeed Tax|06f89534-d4f2-4efe-823b-b8fa74bbc6c5\\u003dBreckwood Shoppes(QA USE Don\\u0027t Edit)|58e83f45-f0fe-409e-8dd3-3cd80d96d87d\\u003dDemo Store (7 Plus + KC)|2ae986f9-ac5c-42a8-8c71-e36dbe591250\\u003dBrink Test Store|da2d3b2f-a29b-4e9d-a5d0-5d5c2725d70d\\u003dTest store 2|f912d247-8420-4c45-96cd-49e862955691\\u003dShipday - Test Store|5ac2eb95-7a74-4338-b91a-45a0de9ed2a4\\u003dTest Store for KT|8358c24e-d5fc-443c-97d0-e0a21466a38e\\u003dSilverware - QA|959650e6-c616-45f1-8e80-6b5e5b507e8e\\u003dIAC - TOAST|3831ddf4-fa61-4eef-971c-f42b9f425c04\\u003dFenway - QA  (Don\\u0027t Use)|6f8e9d8a-0088-4091-9d30-ad6068c6cc7f\\u003dTest 123|d8cc04d1-a4fa-4eec-b042-0ac70501c043\\u003dRevel Catering|06f3898b-3148-4ea4-a644-a129a35270d9\\u003dSeattle - QU (QA Use)|b1ba2954-85f6-4d23-8553-5f83dd7a06cb\\u003dBee Store (DPAR)|8c1c0289-d32b-4e28-836c-312197fda3d0\\u003dDoordash orders|985487d9-f4bf-4f57-a964-436d2fca267a\\u003dWOV2 Test Store - DO NOT EDIT QA|952e1839-75f2-4d4b-9949-3760579583b8\\u003dTower Sq (DON\\"T EDIT)|a8c7020b-27ff-4373-9896-abc4f41d3f59\\u003dHenderson (Revel)|4edfecb1-d8ef-40e5-b193-007cd9bbfc80\\u003dThrottling Test|f3f970b8-e560-4853-b6ef-0ea4bc3a42e8\\u003dFiddleheads at Bayshore|d181b335-12b1-4975-b6e5-6e9f45d7bfc5\\u003dMilos Spreedly|9a7e4879-7562-4a86-9478-adb467842ae3\\u003dCatalog Testing store (Don\\u0027t Edit)|a8bd1f53-6172-4f1f-b78b-50c7cf052151\\u003dBoston QA (Incentivio DON\\"T EDIT)|37a5dcaa-f644-4828-b173-fd6d4aa00199\\u003dDo Not use (Its boba replica)|040b41cb-cf0e-4f24-9f85-60527cd5122b\\u003dRUSH QA Store for Cypress|15ce3fc0-fcb8-433f-bc57-a5540eb526f3\\u003dTemporary Store|5e0dab8c-af8e-40f3-aaed-c9bccda327c8\\u003dUber orders - Test|90269ca5-b39c-472b-8279-07bb5a4bc393\\u003dTest Store|00ac95f7-35a2-45c5-9dbf-8808858a7b6f\\u003dStore SMS Testing only|458d1f38-daeb-4845-8531-7d6dc2cb2a8a\\u003dDo Not use (From the Herath Replica)|b865bd5f-1a1f-4c92-8b12-9a5569c41e01\\u003dQu Store New|a335ec88-18f1-417f-a67d-de181e1109e2\\u003dMilos Test (Timeout)|a92f7eaf-7ddd-4262-802d-f4148bb692af\\u003dClover store|63b9f30f-62fb-494c-8995-3cc939422f8f\\u003dkupfertandkim - Yorkville|331f780d-2b59-45a1-a265-bf8247b67923\\u003dShipday Orders|91699bcd-bfca-47ac-b288-39bd0231a3ed\\u003dFenway location 2 - Nightly import testing","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca\\u003dQu Demo;c7c8efd4-7bb8-43ec-be86-063b06f9a5da\\u003dQu Store"]',
      offerRedemptionExpired: true,
    },
    {
      offerId: 'b6edacc4-b31d-4bc5-afc5-cff36b4fb003',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: '%100% OFF OFFER',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: {
        '*': 'c8eacca9-b1a3-4893-a913-edf624911d24',
      },
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2020-08-18T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2020-08-17T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.ACTIVITY,
      displayInfo: [
        {
          languageCode: 'EN',
          title: '100% OFF OFFER QA use only',
          shortDescription: '100% OFF OFFER QA use only',
          longDescription: '100% OFF OFFER QA use only',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/happy-halloween-spooky_0ae055c3e2be4f2eb15764667214bcdd.gif',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/happy-halloween-spooky_f1c233404c1c4af481b7bc2e22a37417.gif',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.PERCENTAGE,
          discountAmount: 0,
          discountPercentage: 1.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.73d2f6a3-a8cc-4632-8b93-79b6f0d3dfeb',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"eventName\\":\\"check-in\\",\\"eventValues\\":[\\"7228c2cf-17d7-47bd-a069-0e0083ced402\\",\\"QA\\",null],\\"valueDefinition\\":[{\\"incentivioId\\":\\"7228c2cf-17d7-47bd-a069-0e0083ced402\\",\\"code\\":\\"QA\\",\\"copyToEventValues\\":\\"[\\\\\\"incentivioId\\\\\\",\\\\\\"code\\\\\\",\\\\\\"beaconid\\\\\\"]\\",\\"type\\":\\"PROMO\\",\\"displayData\\":\\"{\\\\\\"title\\\\\\":\\\\\\"QA\\\\\\"}\\"}]}","expressionName":"EVENT"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '11/06/2021 04:09:17',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: ['CHECK_IN'],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: true,
    },
    {
      offerId: '3192ebec-155a-4585-a92d-f1362c62fd09',
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: '%12% Offer',
      offerStatus: OfferStatusType.ACTIVE,
      offerType: 'Basket',
      numOffersToDistribute: 100000000000000000,
      numOffersInInventory: 100000000000000000,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: {
        SMS: [],
      },
      redemptionEndDateType: null,
      redemptionStartDate: '2022-10-20T00:00:00',
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: '2022-10-20T00:00:00',
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.ACTIVITY,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Display Title',
          shortDescription: 'Short Description',
          longDescription: 'Long Description',
          smallImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/2_6fbff035353e43209819bc15b614925b.jpg',
          mediumImage:
            'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/o/3_b517c787f34d4458974c75e180cf05b9.jpg',
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 6000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: 'palmlanedev.b787f3b4-d50f-4d7c-808f-13dd460afbe7',
      distributionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"eventName\\":\\"check-in\\",\\"eventValues\\":[\\"e03eefa6-a8cc-4898-ac16-5e8a1d8b3808\\",\\"IS\\",null],\\"valueDefinition\\":[{\\"incentivioId\\":\\"e03eefa6-a8cc-4898-ac16-5e8a1d8b3808\\",\\"code\\":\\"IS\\",\\"copyToEventValues\\":\\"[\\\\\\"incentivioId\\\\\\",\\\\\\"code\\\\\\",\\\\\\"beaconid\\\\\\"]\\",\\"type\\":\\"PROMO\\"}]}","expressionName":"EVENT"}',
      redemptionRuleSet:
        '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"true","expressionName":"EVERYONE"}',
      createdDate: '10/20/2022 10:11:03',
      updatedDate: '11/22/2022 12:36:36',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: ['CHECK_IN'],
      enableReach: true,
      reach:
        '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c;*","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca;*"]',
      reachDisplayInfo:
        '["1b63163d-1aba-4944-bbc1-ebc495d9dc5c;73c25df9-b8d5-4d89-9944-dbbdc0c8a117\\u003dtest;185402a5-744e-4036-8e38-7b04ec8b3634\\u003dPhoenix Location","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;84ace984-71ec-4488-b7fd-cb7bc24a881c\\u003dElastiCache Testing;f6a868d1-2b4d-4dde-8e5a-da608add442c\\u003dElastiCache Migration 1","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;7f3ffb13-7c1c-4909-9efb-b067b1728f12\\u003dDev Team Onlyy;e24a7c69-9caa-43bd-8247-5f9d3646da56\\u003dTest Store for Duplicate|1b7e9d78-4a01-497b-81a8-36c061db273d\\u003dDO NOT USE - HM Lake Mary|eaa78621-f849-4267-8235-1c280f8e183f\\u003dDEV TEAM - TOAST Copy|5c8f4f36-6f46-47de-8340-1eb542e3d7a4\\u003dCatalog Testing store 2 (Don\\u0027t Edit)|684118df-6aaa-4b8c-a01c-4714018d6330\\u003dDEV TEAM - SQUARE|1a972340-2b41-42d7-8dd0-ca7244a4c101\\u003dDEV TEAM - TOAST|feddeb45-997a-4eae-a32d-0acc3dceebfe\\u003dDEV TEAM - QU|c1f73a97-8a64-4bff-9f37-bd71b6ccdc56\\u003dDEV TEAM - SILVERWARE|12e9ccb5-c1db-47ad-864f-4fb533d18804\\u003dDEV TEAM - LIGHTSPEED|d92ba21d-3595-483f-84f6-915378f4eb88\\u003dDEV TEAM - REVEL|d672e224-a310-4e80-a389-550e09d82e66\\u003dDEV TEAM - BRINK|eef2bafb-7ade-4753-ad2c-3b783ed12f4e\\u003ddelete test|f58c34ac-7ee0-4d39-a663-ef5881b0a217\\u003d2050 Yonge copy - DO NOT USE|6d82d135-7eee-402f-8d63-9f6650aa35d9\\u003dTest New Store|8822e1ef-3f18-44b3-b311-fc4cbe589517\\u003dDEV TEAM - TEST|4cda6f5d-bd61-4669-866c-550356715b66\\u003dTest - Location|9f8aae09-49f8-4f68-b3d3-478838362254\\u003dBoston DEV|436e3b11-9d1f-4712-abca-875f432a0384\\u003dLightspeed 3|7ec07547-028e-4fce-9002-b850580f1752\\u003dDEV TEAM - OTTER|d1e60049-c35a-44f6-94d0-4af64c0ef53d\\u003dTest Store for test mode","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;9458ce51-e44a-451a-b8a3-beb15d1ddbaf\\u003dOtter Demo;98d87416-a53b-48a4-88cf-d8431e72cf47\\u003dOtter Demo Store","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;4c4ade61-7973-46f0-820f-4bf5bc783e0c\\u003dINCENTIVIO;39df95a3-439a-4145-9560-aa2ec14d063e\\u003dDuplicate Store|747f00fe-1285-4001-8f5d-962ead578e9b\\u003dRegression Testing Store|3d922e86-2f3f-41b6-a1ce-19ffe94895ad\\u003dDecatur (Lightspeed)|5dad0de2-0a3b-41ee-aba6-6d928f0f39b0\\u003dFenway Kiosk New Dev (Don\\u0027t Edit)|fb6c1227-78b1-4d62-a670-c146ef060983\\u003dMilos QA Sync Test (NCC)|76cfba32-e232-49bf-acde-4aec97aef1f9\\u003dEnfield (QA US  DONT EDIT)|2efed814-f037-44d8-8475-a2772d43311e\\u003dDuplicate Store 2|560894f4-84a8-4f56-88ef-5e6f623d0859\\u003dQU Testing Store -QA|43a86007-a664-495a-bdac-fa90683283fc\\u003dTest Store22|419418fb-788d-461d-aad6-fb2d613cd830\\u003dClover Transaction Store|92988170-ccb2-4069-aae9-1e91fd65fd41\\u003dLightspeed - Without Tax Classes|e410319a-d820-4da2-b08e-5e3242188a28\\u003dToronto OTTER (QA Use)|7a631130-8800-4efa-bbab-4d159aa80945\\u003dDine in Boston QA2 (Incentivio KC Test)|91e91878-6dfb-4adc-b5dd-dd1f692c6a9c\\u003dLightspeed Tax|06f89534-d4f2-4efe-823b-b8fa74bbc6c5\\u003dBreckwood Shoppes(QA USE Don\\u0027t Edit)|58e83f45-f0fe-409e-8dd3-3cd80d96d87d\\u003dDemo Store (7 Plus + KC)|2ae986f9-ac5c-42a8-8c71-e36dbe591250\\u003dBrink Test Store|da2d3b2f-a29b-4e9d-a5d0-5d5c2725d70d\\u003dTest store 2|f912d247-8420-4c45-96cd-49e862955691\\u003dShipday - Test Store|5ac2eb95-7a74-4338-b91a-45a0de9ed2a4\\u003dTest Store for KT|8358c24e-d5fc-443c-97d0-e0a21466a38e\\u003dSilverware - QA|959650e6-c616-45f1-8e80-6b5e5b507e8e\\u003dIAC - TOAST|3831ddf4-fa61-4eef-971c-f42b9f425c04\\u003dFenway - QA  (Don\\u0027t Use)|6f8e9d8a-0088-4091-9d30-ad6068c6cc7f\\u003dTest 123|d8cc04d1-a4fa-4eec-b042-0ac70501c043\\u003dRevel Catering|06f3898b-3148-4ea4-a644-a129a35270d9\\u003dSeattle - QU (QA Use)|b1ba2954-85f6-4d23-8553-5f83dd7a06cb\\u003dBee Store (DPAR)|8c1c0289-d32b-4e28-836c-312197fda3d0\\u003dDoordash orders|985487d9-f4bf-4f57-a964-436d2fca267a\\u003dWOV2 Test Store - DO NOT EDIT QA|952e1839-75f2-4d4b-9949-3760579583b8\\u003dTower Sq (DON\\"T EDIT)|a8c7020b-27ff-4373-9896-abc4f41d3f59\\u003dHenderson (Revel)|4edfecb1-d8ef-40e5-b193-007cd9bbfc80\\u003dThrottling Test|f3f970b8-e560-4853-b6ef-0ea4bc3a42e8\\u003dFiddleheads at Bayshore|d181b335-12b1-4975-b6e5-6e9f45d7bfc5\\u003dMilos Spreedly|9a7e4879-7562-4a86-9478-adb467842ae3\\u003dCatalog Testing store (Don\\u0027t Edit)|a8bd1f53-6172-4f1f-b78b-50c7cf052151\\u003dBoston QA (Incentivio DON\\"T EDIT)|37a5dcaa-f644-4828-b173-fd6d4aa00199\\u003dDo Not use (Its boba replica)|040b41cb-cf0e-4f24-9f85-60527cd5122b\\u003dRUSH QA Store for Cypress|15ce3fc0-fcb8-433f-bc57-a5540eb526f3\\u003dTemporary Store|5e0dab8c-af8e-40f3-aaed-c9bccda327c8\\u003dUber orders - Test|90269ca5-b39c-472b-8279-07bb5a4bc393\\u003dTest Store|00ac95f7-35a2-45c5-9dbf-8808858a7b6f\\u003dStore SMS Testing only|458d1f38-daeb-4845-8531-7d6dc2cb2a8a\\u003dDo Not use (From the Herath Replica)|b865bd5f-1a1f-4c92-8b12-9a5569c41e01\\u003dQu Store New|a335ec88-18f1-417f-a67d-de181e1109e2\\u003dMilos Test (Timeout)|a92f7eaf-7ddd-4262-802d-f4148bb692af\\u003dClover store|63b9f30f-62fb-494c-8995-3cc939422f8f\\u003dkupfertandkim - Yorkville|331f780d-2b59-45a1-a265-bf8247b67923\\u003dShipday Orders|91699bcd-bfca-47ac-b288-39bd0231a3ed\\u003dFenway location 2 - Nightly import testing","1b63163d-1aba-4944-bbc1-ebc495d9dc5c;5f7e5664-8e7c-48fc-aaee-8e9b35b2fdca\\u003dQu Demo;c7c8efd4-7bb8-43ec-be86-063b06f9a5da\\u003dQu Store"]',
      offerRedemptionExpired: true,
    },
    {
      offerId: null,
      campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
      campaignTitle: 'test one',
      programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
      title: 'Draft Offer',
      offerStatus: null,
      offerType: 'Basket',
      numOffersToDistribute: 0,
      numOffersInInventory: 0,
      externalIdMap: null,
      priority: 1,
      channelTemplateSetMap: { SMS: [] },
      redemptionEndDateType: null,
      redemptionStartDate: null,
      redemptionEndDate: null,
      redemptionEndTime: null,
      distributionEndDateType: null,
      distributionStartDate: null,
      distributionEndDate: null,
      awardPointsAsPending: false,
      distributionMode: DistributionMode.AUTO,
      displayInfo: [
        {
          languageCode: 'EN',
          title: 'Draft Offer',
          shortDescription: 'Draft Offer',
          longDescription: 'Draft Offer',
          smallImage: null,
          mediumImage: null,
        },
      ],
      offerReward: {
        rewardType: RewardType.DISCOUNT,
        discount: {
          extDiscountId: null,
          discountTarget: DiscountTarget.ORDER,
          discountItemQualifier: null,
          discountType: DiscountType.AMOUNT,
          discountAmount: 1000,
          discountPercentage: 0.0,
        },
        qualifier: null,
        pointsReward: 0,
        awardPointsAsPending: false,
        pointsCost: 0,
        awardForEachQualifyingUnit: false,
      },
      merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
      codeType: CodeType.FIXED,
      codeFormat: CodeFormat.QRCODE,
      offerCode: null,
      distributionRuleSet: null,
      redemptionRuleSet: null,
      createdDate: '01/10/2023 09:00:00',
      updatedDate: '01/10/2023 09:00:00',
      isLoyaltyOffer: false,
      redeemType: RedeemType.PURCHASE,
      purchaseTypes: [PurchaseTypes.INTEGRATED],
      activityNames: [],
      enableReach: false,
      reach: null,
      reachDisplayInfo: null,
      offerRedemptionExpired: false,
      isDraft: true,
      draftOfferId: 'a1b2c3d4-e5f6-7890-abcd-ef1234567890',
    },
  ],
  paging: {
    total: 980,
    count: 11,
    totalPages: 98,
    currentPage: 0,
  },
};

export const getOffer: GetOfferResult = {
  offerId: '9243f7ee-bae8-4add-b6ec-42d3919c439b',
  campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
  campaignTitle: 'test one',
  programId: 'e5f826bd-6199-4ef6-835c-a8c0f5a9b861',
  title: 'Test Offer',
  offerStatus: OfferStatusType.ACTIVE,
  offerType: 'Basket',
  numOffersToDistribute: 100000000000000000,
  numOffersInInventory: 100000000000000000,
  externalIdMap: null,
  priority: 1,
  channelTemplateSetMap: {
    SMS: [],
  },
  redemptionEndDateType: EndDateType.NEVER_EXPIRE,
  redemptionStartDate: '2022-11-14T00:00:00',
  redemptionEndDate: null,
  redemptionEndTime: null,
  distributionEndDateType: EndDateType.NEVER_EXPIRE,
  distributionStartDate: '2022-11-14T00:00:00',
  distributionEndDate: null,
  awardPointsAsPending: false,
  distributionMode: DistributionMode.AUTO,
  displayInfo: [
    {
      languageCode: 'EN',
      title: 'Test Offer',
      shortDescription: 'Short Description',
      longDescription: 'Long Description',
      smallImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
      mediumImage:
        'https://s3.amazonaws.com/incentdev/1b63163d-1aba-4944-bbc1-ebc495d9dc5c/s/default_tile_add025a701cc4c74ab66aebbb6b4f777.png',
    },
  ],
  offerReward: {
    rewardType: RewardType.DISCOUNT,
    discount: {
      extDiscountId: null,
      discountTarget: DiscountTarget.ITEM,
      discountItemQualifier: {
        qualifierSelectionMode: QualifierSelectionMode.ONE,
        qualifierItems: [
          {
            attributeId: '60997a3a60b20eb4a15d8d83',
            attributeObjectName: '2050 Yonge copy - DO NOT USE - (MOD) Allergy',
            count: 1,
            extAttributeId:
              'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae-extTargetingId',
            itemAttribute: ItemAttribute.ITEM,
            targetLevel: TargetLevel.ITEM,
          },
        ],
      },
      discountType: DiscountType.PERCENTAGE,
      discountAmount: 2000,
      discountPercentage: 1,
    },
    qualifier: {
      qualifierSelectionMode: QualifierSelectionMode.ONE,
      qualifierItems: [
        {
          attributeId: '60997a3a60b20eb4a15d8d83',
          attributeObjectName: '2050 Yonge copy - DO NOT USE - (MOD) Allergy',
          count: 2,
          extAttributeId: 'a5b0d301-e0c8-4f26-89ea-fcf4b61c11ae-extTargetingId',
          itemAttribute: ItemAttribute.ITEM,
          targetLevel: TargetLevel.ITEM,
        },
      ],
    },
    pointsReward: 0,
    awardPointsAsPending: false,
    pointsCost: 0,
    awardForEachQualifyingUnit: false,
  },
  merchantId: '4c4ade61-7973-46f0-820f-4bf5bc783e0c',
  codeType: CodeType.FIXED,
  codeFormat: CodeFormat.QRCODE,
  offerCode: 'palmlanedev.503aacf0-c5e7-4ca2-9843-adb525afdc97',
  distributionRuleSet:
    '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"attributeName\\":\\"1998_TAG\\",\\"attributeValues\\":[\\"TRUE\\"],\\"dataType\\":\\"COLLECTION\\"}","expressionName":"EXTENDED_ATTRIBUTES","extendedAttributes":{"attributeTitle":"1998_Tag"}}',
  redemptionRuleSet:
    '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"attributeName\\":\\"1998_TAG\\",\\"attributeValues\\":[\\"TRUE\\"],\\"dataType\\":\\"COLLECTION\\"}","expressionName":"EXTENDED_ATTRIBUTES","extendedAttributes":{"attributeTitle":"1998_Tag"}}',
  createdDate: '11/14/2022 10:44:46',
  updatedDate: '01/26/2023 10:43:01',
  isLoyaltyOffer: false,
  redeemType: RedeemType.PURCHASE,
  purchaseTypes: [PurchaseTypes.INTEGRATED],
  activityNames: [],
  enableReach: false,
  reach: null,
  reachDisplayInfo: null,
  offerRedemptionExpired: true,
  distributionStores: [],
  redemptionStores: [],
  autoRedeem: false,
  redistributionMode: RedistributionMode.ONCE,
  redistributionTimeout: null,
  channels: [Channels.INAPP],
  formattingSetting: {
    codeFormat: CodeFormat.QRCODE,
    codeType: CodeType.FIXED,
    fixedCode: 'palmlanedev.503aacf0-c5e7-4ca2-9843-adb525afdc97',
    prefix: null,
    trailingCodeLength: null,
  },
  distributionSchedule: {
    startDate: '2022-11-14T00:00:00',
    endDate: null,
    scheduleDays: [
      ScheduleDays.MONDAY,
      ScheduleDays.TUESDAY,
      ScheduleDays.WEDNESDAY,
      ScheduleDays.THURSDAY,
      ScheduleDays.FRIDAY,
      ScheduleDays.SATURDAY,
      ScheduleDays.SUNDAY,
    ],
    timeSlots: [{ startTime: '07:00:00', endTime: '08:00:00' }],
  },
  distributionJobId: 'bfab336e-c25a-4657-9f37-33005607e454',
  distributionPersonaId: null,
  redemptionPersonaId: null,
  timezone: 'Asia/Colombo',
  enableGuestCheckout: false,
};

export const getOfferDistributionSettings: GetOfferDistributionSettingsResult =
  {
    distributionMode: DistributionMode.AUTO,
    autoRedeem: false,
    redistributionMode: RedistributionMode.ONCE,
    redistributionTimeout: null,
    channels: [Channels.INAPP],
    channelTemplateSetMap: { SMS: [] },
    numOffersToDistribute: 100000000000000000,
    formattingSetting: {
      codeFormat: CodeFormat.QRCODE,
      codeType: CodeType.FIXED,
      fixedCode: 'palmlanedev.503aacf0-c5e7-4ca2-9843-adb525afdc97',
      prefix: null,
      trailingCodeLength: null,
    },
    distributionSchedule: {
      startDate: '2022-11-14T00:00:00',
      endDate: null,
      scheduleDays: [
        ScheduleDays.MONDAY,
        ScheduleDays.TUESDAY,
        ScheduleDays.WEDNESDAY,
        ScheduleDays.THURSDAY,
        ScheduleDays.FRIDAY,
        ScheduleDays.SATURDAY,
        ScheduleDays.SUNDAY,
      ],
      timeSlots: [{ startTime: '07:00:00', endTime: '08:00:00' }],
    },
    distributionJobId: 'bfab336e-c25a-4657-9f37-33005607e454',
    redemptionStartDate: '2022-11-14T00:00:00',
    redemptionEndDate: null,
    distributionStartDate: '2022-11-14T00:00:00',
    distributionEndDate: null,
    distributionRuleSet:
      '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"attributeName\\":\\"1998_TAG\\",\\"attributeValues\\":[\\"TRUE\\"],\\"dataType\\":\\"COLLECTION\\"}","expressionName":"EXTENDED_ATTRIBUTES","extendedAttributes":{"attributeTitle":"1998_Tag"}}',
    redemptionRuleSet:
      '{"ruleType":"EXPRESSION","operator":"EQ","expressionValue":"{\\"attributeName\\":\\"1998_TAG\\",\\"attributeValues\\":[\\"TRUE\\"],\\"dataType\\":\\"COLLECTION\\"}","expressionName":"EXTENDED_ATTRIBUTES","extendedAttributes":{"attributeTitle":"1998_Tag"}}',
    distributionPersonaId: null,
    redemptionPersonaId: null,
    timezone: 'Asia/Colombo',
    distributionEndDateType: EndDateType.NEVER_EXPIRE,
    redemptionEndDateType: EndDateType.NEVER_EXPIRE,
    redemptionEndTime: null,
    enableGuestCheckout: false,
  };

export const sendOffer = { offers: [] };

export const getDraftOffer: Partial<GetDraftOfferResult> = {
  draftOfferId: '00000000-0000-0000-0000-000000000002',
  title: 'test one',
  campaignId: 'b94b7cfc-a829-4f16-9bd5-5ce80c4752ab',
  ...getOfferDistributionSettings,
};
